
  import { Vue, Component, Prop } from 'vue-property-decorator';
  import { eventBus, mcEvents } from "@/utils";
  import { ToastOptions } from "@/models";
  import { data } from "./mc-toast.data";

  @Component
  export default class McToastTests extends Vue {
    syncToast!: ToastOptions;
    dateToast!: ToastOptions;
    countToast!: ToastOptions;



    showCountToast() {
      this.$bvToast.show('countTest');
    }
    showDateToast() {
      this.$bvToast.show('dateTest');
    }
    showSyncToast() {
      this.$bvToast.show('syncTest');
    }

    created() {
      this.syncToast = data.syncToast;
      this.dateToast = data.dateToast;
      this.countToast = data.countToast;
    }

    mounted() {
    }
  }
